import paymentCards, { backend_to_cleave_type } from "@/settings/payment-brands";

export const getPaymentBrandName = (type = "") => {
  type = type.toLowerCase();
  return paymentCards[backend_to_cleave_type[type] || type || "defult"].name || type;
}

export const getPaymentBrandIcon = (type = "") => {
  type = type.toLowerCase();
  return paymentCards[backend_to_cleave_type[type] || type || "defult"].icon || 'default';
}
